import UserInfo from "./components/UserInfo/UserInfo";

export default UserInfo;
